import './_editorial-carousel-slide.scss';

export default () => {};
